import styled from '@emotion/styled';
import {Box, Grid, ImageList, ImageListItem, Typography} from '@mui/material';
import {useState} from 'react';
import {Section, MediaSection, MediaComponent} from '../../../../api/models';
import {UploadModal} from './UploadModal';
import {useScreenDetector} from '../../../../api/hook';

const BackgroundBoxWrapper = styled(Box)<{backgroundColor: string}>(({backgroundColor}) => ({
    // paddingTop: 32,
    paddingLeft: 54,
    paddingRight: 54,
    paddingBottom: 32,
    margin: 0,
    backgroundColor: backgroundColor,
}));

interface Props {
    section: Section;
    websiteId: string;
    throwSnackbarMessage: (message: string) => void;
    refetch: VoidFunction;
}

const StandardImageList = (props: {images: MediaComponent[]}) => {
    const {isDesktop, isTablet, isMobile} = useScreenDetector();
    const numCols = isDesktop ? 4 : isTablet && !isMobile ? 2 : 1;
    return (
        <ImageList gap={5} variant='masonry' cols={numCols} rowHeight={220}>
            {props.images.map((item: MediaComponent, index: number) => (
                <ImageListItem key={item.id}>
                    <img srcSet={item.url} src={item.url} alt={`Shop Image ${index}`} loading='lazy' />
                </ImageListItem>
            ))}
        </ImageList>
    );
};

export const MediaCompanionComponent = (props: Props) => {
    const [open, setOpen] = useState(false);

    return (
        <div>
            <BackgroundBoxWrapper backgroundColor={'white'}>
                <Grid container>
                    <Grid item md={10} xs={10} sm={10}>
                        <Typography
                            sx={{
                                marginTop: 1,
                                fontWeight: 700,
                                color: 'black',
                                fontFamily: 'Poppins',
                            }}
                            variant='body1'>
                            Media Images
                        </Typography>
                    </Grid>
                    <Grid item md={2} xs={2} sm={2}>
                        <div onClick={() => setOpen(true)}>
                            <Typography
                                sx={{
                                    marginTop: 1,
                                    fontWeight: 300,
                                    color: 'blue',
                                    cursor: 'pointer',
                                    fontFamily: 'Poppins',
                                    textDecorationLine: 'underline',
                                }}
                                variant='body2'>
                                Add image
                            </Typography>
                        </div>
                    </Grid>
                </Grid>
                <br />
                <Grid container>
                    <Grid item sm={12} xs={12} md={12}>
                        <StandardImageList images={(props.section as MediaSection).mediaContent} />
                    </Grid>
                </Grid>
            </BackgroundBoxWrapper>
            <UploadModal
                open={open}
                setOpen={(newState) => setOpen(newState)}
                sectionId={(props.section as MediaSection).id}
            />
        </div>
    );
};
